
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import CKEditor from '@ckeditor/ckeditor5-vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface Payment {
    id: string;
    name: string;
    code: string;
    type: string;
    description: string;
}
interface FPayment {
    name: string;
    code: string;
    type: string;
    description: string;
}
export default defineComponent({
    name: "Combination-code",
    watch: {
        //Lưu xong (submit nằm trong setup, không gọi được method của Options) -> nạp lại bảng từ server
        reloadTick(this: any) {
            this.getData()
        },
    },
    components: {
        Datatable,
        ckeditor: CKEditor.component
    },
    data() {
        return {
            editorConfig: {}
        }
    },
    methods: {
        onReady( editor )  {
        //Insert the toolbar before the editable area.
        setTimeout(() => {
          console.log('editor.ui.view.toolba',editor.ui.view.toolbar)
          editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            // editor.ui.view.toolbar.element,
            
            editor.ui.getEditableElement()
          );
        }, 100);
        this.editorModel = editor
    },
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "name": "",
                "code": "",
                "type":  "",
                "description": ""
            }
            this.formData = temp
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa phí khác này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`/setting/generalsetting/${record.id}`).then(() => this.getData())
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            this.resetDataForm()
            this.idFormEdit = record.id
            await axios.get(`/setting/generalsetting/${record.id}`)
                .then(({ data }) => {
                    this.formData = {...data, fee: parseInt(data.fee)}
                    this.isEdit = true
                    this.kt_modal_add_combination?.click()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        async getData(){
            await axios.get(`/setting/generalsetting`)
                .then(({ data }) => {
                    //Reset trước khi đổ: trước đây chỉ push nên gọi getData lần 2 là danh sách nhân đôi
                    this.initRows = []
                    this.optionType = []
                    data.forEach(item => {
                        let temp = {
                            id: item.id,
                            name: item.name,
                            code: item.code,
                            type:  item.type,
                            description: item.description
                        }
                        this.initRows.push(temp)
                        if(!this.optionType.includes(item.type) && item.type != null){
                            this.optionType.push(item.type)
                        }
                    })
                    this.applyFilter()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        
    },

    async mounted() {
        this.getData()
    },
    setup() {
        const editor = DecoupledEditor
        const editorModel = ref({} as any)
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');
        const optionType = ref<Array<string>>([])
        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "Hình thức",
                key: "name",
                class: "min-w-220px",
                sortable: true,
            },{
                name: "Loại",
                key: "type",
                class: "min-w-110px",
                sortable: false,
            },{
                name: "Mô tả",
                key: "description",
                class: "w-100",
                sortable: false,
            },{
                name: "HÀNH ĐỘNG",
                key: "actions",
                sortable: false,
                class: "text-center min-w-50px"
            },
        ]);
        const formData = ref<FPayment>({
                "name": "",
                "code": "",
                "type":  "",
                "description": ""  })
        const tableData = ref<Array<Payment>>([]);
        //initRows = dữ liệu gốc; tableData = phần đang hiển thị sau tìm kiếm/lọc
        const initRows = ref<Array<Payment>>([]);
        const search = ref('');
        const filterType = ref('');
        const expandedRows = ref<string[]>([]);   //các dòng đang mở rộng phần Mô tả
        //Đếm số lần cần nạp lại bảng — Options `watch.reloadTick` gọi getData()
        const reloadTick = ref(0);
        //Bản ghi cổng nhập học đọc theo MÃ -> không cho xóa
        const SYSTEM_CODES = ['PAYMENT_BANK_INFO', 'PAYMENT_ACCOUNTANT_INFO']
        function isSystemRow(row: any) {
            return SYSTEM_CODES.includes(row?.code)
        }
        function typeLabel(type: any) {
            if (type == 'payment') { return 'Thanh toán' }
            if (type == 'source') { return 'Nộp hồ sơ' }
            return type || '—'
        }
        function toggleRow(id: any) {
            const i = expandedRows.value.indexOf(id)
            if (i === -1) { expandedRows.value.push(id) } else { expandedRows.value.splice(i, 1) }
        }
        //Tìm kiếm + lọc Loại dùng chung 1 hàm, luôn dựng lại từ initRows
        function applyFilter() {
            let rows = [...initRows.value]
            const kw = search.value.trim().toUpperCase()
            if (kw) {
                rows = rows.filter((r: any) => [r.code, r.name, String(r.description || '').replace(/<[^>]*>/g, ' ')]
                    .filter(Boolean).join(' ').toUpperCase().indexOf(kw) !== -1)
            }
            if (filterType.value) {
                rows = rows.filter((r: any) => r.type == filterType.value)
            }
            tableData.value = rows
        }
        const validateCode = (rule: any, value: any, callback: any) => {
            let method = isEdit.value ? 'put' : 'post'
            if (value === '') {
                callback(new Error('Vui lòng điền trường này'))
            } else if (value == 'PAYMENT_BANK_INFO' || value == 'PAYMENT_ACCOUNTANT_INFO') {
                if(method == 'post') callback(new Error("Mã này đã được tạo"))
                callback()
            } else {
                callback()
            }
        }
        const formRef = ref<HTMLFormElement | null>(null);
        const rules = ref({
            name: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
            code: [{ validator: validateCode, trigger: 'blur' }],
            type: [
                {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
                },
            ],
        })
        const submit = () => {
            if (!formRef.value) return;
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let data = {
                        "name": formData.value.name != "" ? formData.value.name : undefined,
                        "code": formData.value.code != "" ? formData.value.code : undefined,
                        "type": formData.value.type != "" ? formData.value.type : undefined,
                        "description": formData.value.description ? formData.value.description : "",
                    }
                    await axios[method](`/setting/generalsetting${id}`, data)
                        .then(() => {
                            //Nạp lại từ server (watch reloadTick -> getData) thay vì vá 1 dòng:
                            //bản vá cũ không đụng initRows nên tìm kiếm/lọc vẫn trả dữ liệu cũ.
                            reloadTick.value++
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        return {
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            Permission,
            submit,
            formData,
            isEdit,
            idFormEdit,
            editorModel,
            editor,
            optionType,
            initRows,
            search,
            filterType,
            expandedRows,
            reloadTick,
            applyFilter,
            isSystemRow,
            typeLabel,
            toggleRow,
        };
    },
});
